<template>
  <div>
    <el-table
      :data="installers"
      v-loading="loading"
      border
      class="app-table"
      empty-text="No installers found"
      :max-height="tableHeight"
    >
      <el-table-column label="Name" min-width="160">
        <template slot-scope="{ row }">
          <div class="installer-name">
            {{ row.fullName || '—' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="email" label="Email" min-width="200" />
      <el-table-column label="Status" width="120">
        <template slot-scope="{ row }">
          <el-tag
            :type="row.isActive === false ? 'danger' : 'success'"
            size="small"
          >
            {{ row.isActive === false ? 'Inactive' : 'Active' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Actions" width="180" align="center">
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            type="warning"
            plain
            :loading="resettingId === row.userId"
            @click="resetPassword(row)"
          >
            <i class="el-icon-key" /> Reset Password
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import LoraApiService from '@/services/LoraApiService'
import loraTableHeight from '@/mixins/loraTableHeight'

export default {
  name: 'LoraInstallers',
  mixins: [loraTableHeight],
  data() {
    return {
      installers: [],
      loading: false,
      resettingId: null
    }
  },
  mounted() {
    this.loadInstallers()
  },
  methods: {
    async loadInstallers() {
      this.loading = true
      try {
        var res = await LoraApiService.getAllInstallers()
        this.installers = res.data || []
      } catch (e) {
        this.$message.error('Failed to load installers')
      } finally {
        this.loading = false
      }
    },
    async resetPassword(installer) {
      try {
        await this.$confirm(
          'Send a password reset email to ' +
            (installer.fullName || installer.email) +
            '?',
          'Reset Password',
          { type: 'warning', confirmButtonText: 'Send Reset Email' }
        )
      } catch {
        return
      }
      this.resettingId = installer.userId
      try {
        await LoraApiService.resetInstallerPassword(installer.userId)
        this.$message.success('Password reset email sent to ' + installer.email)
      } catch (e) {
        this.$message.error('Failed to send reset email')
      } finally {
        this.resettingId = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a2332;
}
.app-table {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
</style>
